import { DataGrid } from "@mui/x-data-grid";
export default function DataTable({ rows, columns }) {
  return (
    <div className="grid-table">
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) =>
          row?.id || row?._id || row?.name || row?.item_name || row.stocked_at
        }
        className="data-table"
      />
    </div>
  );
}
